import { Component, OnInit, OnDestroy, ElementRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { TeamModel } from '../../../@core/models/team.model';
import { DataService } from '../../../@core/services/data.service';
import { Subscription } from 'rxjs';
import { TeamInterface, SiteNewModel, ProducInterface } from '../../../@core/models/site-data.model';
import { MatDialog } from '@angular/material/dialog';
import * as Sentry from "@sentry/browser";
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProductModel } from '../../../@core/models/product.model';
import { AnalyticsService } from '../../../@core/services/analytics.service';


@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductsMaterialComponent implements OnInit, OnDestroy {

  title: string;
  subTitle: string;
  backgroundColor: string;
  titleColor: string;
  fontWeight: string;
  subTitleColor: string;
  titleInputValue: string;
  subTitleInputValue: string;
  titleSize: string;
  productsData: ProductModel[];
  subscription: Subscription;
  data: ProducInterface;
  classBuilder: string;
  classMember: string = '';
  ClassEdit: string = '';
  active: boolean = false;
  position: number = 0;
  activatePadding: boolean = false;
  moduleInfo: string;
  editOn: boolean = false;
  editOnTitle: boolean = false;
  editOnSubTitle: boolean = false;
  keepAlive: boolean = false;
  siteId: string = '';
  loading: boolean = true;
  allElementAnimation: string;
  textAnimation: string;
  itemsAnimation: string;
  @ViewChild('titleInput', { static: false }) titleInputEl: ElementRef;
  @ViewChild('subTitleInput', { static: false }) subTitleInputEl: ElementRef;

  constructor(
    private dataService: DataService,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private analyticsService: AnalyticsService
  ) { }

  ngOnInit() {
    if (this.data.animation) {
      this.allElementAnimation = this.data.animation.allElement != '' ? this.data.animation.allElement : undefined;
      this.textAnimation = this.data.animation.text != '' ? this.data.animation.text : undefined;
      this.itemsAnimation = this.data.animation.items != '' ? this.data.animation.items : undefined;

    }
    this.loading = false
    Sentry.configureScope(function (scope) {
      scope.setTag("component", "ProductsComponent");
    });
    this.subscription = this.dataService.getSiteId().subscribe(siteId => {
      this.siteId = siteId;
    });
    this.moduleInfo = JSON.stringify({ position: this.position, new: false });

    this.title = this.data.title;
    this.titleInputValue = this.data.title;
    this.fontWeight = this.data.fontWeight;
    this.titleSize = this.data.titleSize ? this.data.titleSize : '';
    this.backgroundColor = this.data.backgroundColor ? this.data.backgroundColor : '';
    this.productsData = this.data.members;
    this.titleColor = this.data.titleColor ? this.data.titleColor : this.dataService.getDefaultColor(this.backgroundColor);
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  clickExternalLink(link) {
    const currentSite = this.dataService.site$.getValue();
    if (currentSite) {
      this.analyticsService.trackConversion(currentSite, 'click');
    }
    window.open(link, "_blank");
  }

  updateUrl($event) {
    const src = $event.target.src;
    $event.target.src = 'https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/gallery/loading.gif';
    setTimeout(() => {
      $event.target.src = src;
    }, 8000);
  }
}
